<template>
  <div v-if="modal" class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-gray-800/60" @click="dismiss" />

    <!-- Modal -->
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4">
      <!-- Header -->
      <div class="px-6 py-4 bg-primary-100 rounded-t-lg flex items-center justify-between">
        <div class="flex items-center gap-2">
          <h3 class="text-base font-semibold text-gray-900">{{ modal.title }}</h3>
          <span
            v-if="queueTotal > 1"
            class="text-xs font-medium text-gray-500 bg-white/70 px-2 py-0.5 rounded-full"
          >{{ queueTotal - queue.length + 1 }} of {{ queueTotal }}</span>
        </div>
        <button class="text-gray-600 hover:text-gray-900" @click="dismiss">
          <FontAwesomeIcon :icon="['fas', 'times']" />
        </button>
      </div>

      <!-- Body -->
      <div class="px-6 py-5 text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
        {{ modal.body }}
      </div>

      <!-- Footer -->
      <div class="px-6 py-4 border-t border-gray-200 flex justify-end">
        <button
          class="bg-primary-500 text-white text-sm font-medium px-4 py-2 rounded hover:bg-primary-600 transition-colors"
          @click="dismiss"
        >
          {{ modal.cta_text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'AnnouncementModal',
  components: { FontAwesomeIcon },
  data() {
    return {
      queue: [],
      queueTotal: 0,
    };
  },
  computed: {
    modal() {
      return this.queue[0] || null;
    },
  },
  watch: {
    '$route'(to) {
      this.checkModal(to);
    },
  },
  methods: {
    async checkModal(route) {
      if (!route.path) return;
      if (!this.$store.state.auth.current_user) return;
      const response = await axios.get('/api/announcements/check/', {
        params: { path: route.path },
      });
      if (response.status === 204) {
        this.queue = [];
        this.queueTotal = 0;
        return;
      }
      this.queue = response.data.modals || (response.data.key ? [response.data] : []);
      this.queueTotal = this.queue.length;
    },
    async dismiss() {
      const key = this.queue[0].key;
      this.queue.shift();
      await axios.post(`/api/announcements/modals/${key}/dismiss/`);
    },
  },
};
</script>
